module.exports = __webpack_public_path__ + "static/media/8.c684ac35.svg";